const DEFAULT_CLASS_NAME = "bg-purple-200";

const DEFAULT_SECONDARY_CLASS_NAME =
  "bg-gradient-to-t from-yellow-300/50 to-yellow-300/50 bg-no-repeat [background-position:0_130%] [background-size:100%_50%]";

const MatchingTextHighlight = ({
  text,
  searchTerms,
  secondarySearchTerms,
  className = DEFAULT_CLASS_NAME,
  secondaryClassName = DEFAULT_SECONDARY_CLASS_NAME,
}: {
  text?: string | null;
  searchTerms: string[];
  secondarySearchTerms?: string[];
  className?: string;
  secondaryClassName?: string;
}): JSX.Element => {
  // Filter out empty search terms and escape special regex characters
  const validTerms = searchTerms
    .filter((term) => term && term.trim().length > 0)
    .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  // Filter out empty search terms and escape special regex characters
  const secondaryValidTerms = secondarySearchTerms
    ?.filter((term) => term && term.trim().length > 0)
    .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  const allValidTerms = [...validTerms, ...(secondaryValidTerms || [])];

  // With no terms the pattern matches at every position and splits the text into
  // single characters, so render it untouched instead.
  if (!text || allValidTerms.length === 0) {
    return <span>{text}</span>;
  }

  // Create regex pattern that matches any of the search terms
  const pattern = new RegExp(`(${allValidTerms.join("|")})`, "gi");

  // Split the text by matches, keeping the delimiters
  const parts = text.split(pattern);

  const getClassName = (isMatch: boolean, isSecondaryMatch?: boolean) => {
    if (isMatch) {
      return className;
    }

    if (isSecondaryMatch) {
      return secondaryClassName;
    }

    return "";
  };

  return (
    <span>
      {parts.map((part, index) => {
        // Check if this part matches any search term (case-insensitive)
        const isMatch = validTerms.some((term) =>
          new RegExp(`^${term}$`, "i").test(part)
        );

        const isSecondaryMatch = secondaryValidTerms?.some((term) =>
          new RegExp(`^${term}$`, "i").test(part)
        );

        return (
          <span key={index} className={getClassName(isMatch, isSecondaryMatch)}>
            {part}
          </span>
        );
      })}
    </span>
  );
};

export default MatchingTextHighlight;
